export * from './email.validator';
export * from './equalPasswords.validator';


// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/validators/index.ts